import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { PersonEntityService } from '../../state/entity-services/person-entity.service';
import { JwtAuthService } from '../services/auth/jwt-auth.service';
import { UrlService } from '../services/url.service';
import { LocalStoreService } from '../services/local-store.service';

@Injectable()
export class PatientGuard implements CanActivate {
  constructor(
    private localStoreService: LocalStoreService,
    private urlService: UrlService,
    private jwtAuthService: JwtAuthService,
    private personEntityService: PersonEntityService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const { person_id, organization: qOrganization } = route.queryParams;
    const user = this.jwtAuthService.getUser();
    const personId = person_id || user?.id;
    if (personId) {
      return this.handlePersonActivation(personId, qOrganization);
    }

    if (!this.router.navigated && route.paramMap.get('state') !== 'boas-vindas') {
      this.redirectTo('/paciente/login/boas-vindas');
      of(false);
    }

    return of(true);
  }

  private handlePersonActivation(personId: number, qOrganization: string = 'mar'): Observable<boolean> {
    console.log('handlePersonActivation');
    return this.personEntityService.crmPersons(personId).pipe(
      switchMap(crmPerson => {
        console.log('crmPerson', crmPerson);
        const { patientAppDigitalStatus = 'NO_STATUS', id: crmPersonId } = crmPerson || {};
        return of(true)
      })
    );
  }

  private generateSelfieLinkAndRedirect(personId: number): Observable<boolean> {
    const savedPosition = this.localStoreService.getItem('lastPosition');
    if (savedPosition) {
      this.redirectTo('/paciente/triagem', { person_id: personId });
    } else {
      this.redirectTo('/paciente/confirmacao/idade', { person_id: personId });
    }

    return of(true);
  }

  private redirectTo(path: string, queryParams = {}): void {
    this.router.navigate([path], { queryParams });
  }
}
